import Vue from 'vue'
import VueRouter from 'vue-router'
import {cookie,isLogin} from '../assets/js/tools.js';
import {Message } from "element-ui";
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path:'/login',
    name:'Login',
    component:()=>import('../views/User/Login/Login.vue')
  },
  {
    path:'/register',
    name:'Register',
    component:()=>import('../views/User/Register/Register.vue')
  },
  {
    path:'/resetPassword',
    name:'ResetPassword',
    component:()=>import('../views/User/ResetPassword/ResetPassword.vue')
  },
  {
    path:'/layout',
    name:'Layout',
    component:()=>import('../views/Layout/Layout.vue'),
    children:[
      {
        path:'/home',
        name:'Home',
        component:()=>import('../views/Home/Home.vue'),
      },
      {
        path:'/homeList',
        name:'HomeList',
        component:()=>import('../views/HomeList/HomeList.vue'),
      },
      {
        path:'/homeSearch',
        name:'HomeSearch',
        component:()=>import('../views/HomeSearch/HomeSearch.vue'),
      },
      {
        path:'/homeDetail',
        name:'HomeDetail',
        component:()=>import('../views/HomeDetail/HomeDetail.vue'),
      },
      {
        path:'/demoApplication',
        name:'DemoApplication',
        component:()=>import('../views/DemoApplication/DemoApplication.vue'),
      },
      {
        path:'/information',
        name:'Information',
        component:()=>import('../views/Information/Information.vue'),
      },
      {
        path:'/informationList',
        name:'InformationList',
        component:()=>import('../views/InformationList/InformationList.vue'),
      },
      {
        path:'/informationDetail',
        name:'InformationDetail',
        component:()=>import('../views/InformationDetail/InformationDetail.vue'),
      },
      {
        path:'/monitor',
        name:'Monitor',
        component:()=>import('../views/Monitor/Monitor.vue'),
      },
      {
        path:'/safeguard',
        name:'Safeguard',
        component:()=>import('../views/Safeguard/Safeguard.vue'),
      },
      {
        path:'/postsale',
        name:'PostSale',
        component:()=>import('../views/PostSale/PostSale.vue'),
      },
      {
        path:'/release',
        name:'Release',
        component:()=>import('../views/Release/Release.vue'),
      },
      {
        path:'/communication',
        name:'Communication',
        component:()=>import('../views/Communication/Communication.vue'),
      },
      {
        path:'/communicationPost',
        name:'CommunicationPost',
        component:()=>import('../views/CommunicationPost/CommunicationPost.vue'),
      },
      {
        path:'/communicationDetail',
        name:'CommunicationDetail',
        component:()=>import('../views/CommunicationDetail/CommunicationDetail.vue'),
      },
      {
        path:'/procurement',
        name:'Procurement',
        component:()=>import('../views/Procurement/Procurement.vue'),
      },
      {
        path:'/productCenter',
        name:'ProductCenter',
        component:()=>import('../views/ProductCenter/ProductCenter.vue'),
      },
      {
        path:'/productDetail',
        name:'ProductDetail',
        component:()=>import('../views/ProductDetail/ProductDetail.vue'),
      },
      {
        path:'/companyCenter',
        name:'CompanyCenter',
        component:()=>import('../views/CompanyCenter/CompanyCenter.vue'),
      },
      {
        path:'/companyDetail',
        name:'CompanyDetail',
        component:()=>import('../views/CompanyDetail/CompanyDetail.vue'),
      },
      {
        path:'/editPassword',
        name:'EditPassword',
        component:()=>import('../views/User/EditPassword/EditPassword.vue'),
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
});
router.beforeEach((to,from,next)=>{
  // if(to.path=='/monitor'){
  //   if(isLogin()){
  //     next();
  //   }
  // }else{  
    next();
  // }

});
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router
